// extracted by mini-css-extract-plugin
var _1 = "NTZ4j";
export { _1 as "recipientsField" }
